






































import { AUTHENTICATION_LOGIN } from '@/modules/authentication/store';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component
export default class extends Vue {
  public email = '';
  public password = '';

  @Action(AUTHENTICATION_LOGIN)
  private doLogin: any;

  public submit() {
    this.doLogin({ email: this.email, password: this.password });
  }
}
